import {
    createPageDefinition,
    RouteServices,
} from 'common/routing/page-definition'
import {
    RegionalHomepageOptions,
    waNewsSegment,
    regionalNewsSegment,
} from './get-regional-homepage'
import { RouteResolution } from 'common/routing/route-resolver'
import { metrics } from 'component-library/__styling/settings'
import { layout } from 'thewest/App.routing'
import { billboardLeaderboardMrec } from '../ad-units'
import { subscriberExclusive } from '../home/subscriber-exclusive'

const heroSegment = layout.component({
    type: 'sierra',
    props: {
        verticalSpacing: 'gridGap',
        fixedRatios: ['16:9'],
        heroImageLayout: 'fill-container-horizontally',
        cardOrientation: {
            type: 'Landscape-Portrait',
            maxBreakpoint: 'md',
        },
        cardLayout: ['hero', 'commonWithBackground'],

        dataDefinitionArgs: {
            type: 'curation',
            name: 'goldfields',
            offset: 0,
            pageSize: 2,
        },
    },
})

const subheroSegment = layout.component({
    type: 'uniform',
    props: {
        section: 'default',
        verticalSpacing: 'lg',
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            { type: 'november', listLength: 5 },
            ['teaserWithBackground'],
            ['noImageWithBackground', 'noImageWithBackground'],
            ['noImageWithBackground', 'noImageWithBackground'],
        ],
        dataDefinitionArgs: {
            type: 'aggregated',
            sources: [
                {
                    type: 'curation',
                    name: 'goldfields',
                    offset: 2,
                    pageSize: 6,
                },
                {
                    type: 'curation',
                    name: 'goldfields',
                    offset: 8,
                    pageSize: 4,
                },
            ],
        },
    },
})

const revChronSegment = {
    type: 'lima',
    props: {
        verticalSpacing: 'lg',
        fontScale: 1.2,
        fixedRatios: ['16:9'],
        hasBackground: true,
        hideTeaser: true,
        initialColumns: 1,
        intermediateColumns: 2,
        finalColumns: 4,
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
            ],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
        ],
        dataDefinitionArgs: {
            type: 'listing',
            topics: ['news/goldfields'],
            includeSubTopics: false,
            paging: {
                page: 1,
                pageSize: 6,
            },
        },
    },
}

export const getKalgoorlieMinerHomepage = (
    services: RouteServices<RouteResolution>,
    options: RegionalHomepageOptions
) => {
    const adTargeting = services.getAdTargeting('home', options.section, 'home')

    return createPageDefinition(
        {
            heading: options.title,
            hideHeading: true,
            pageType: 'static',
            pageMeta: {
                title: options.title,
                description: options.description,
            },
            socialMeta: {
                description: options.socialDescription,
            },
            noMetaTitleTemplate: true,
            adTargeting,
            section: options.section,
        },
        {
            type: 'thor',
            props: {
                hasBackgroundFill: false,
                containerWidth: metrics.thewest.mainContentWidth,
                horizontalGutters: true,
                verticalGutters: true,
            },
            contentAreas: {
                main: [
                    heroSegment,
                    subheroSegment,
                    ...billboardLeaderboardMrec('one'),
                    revChronSegment,
                    subscriberExclusive(true),
                    ...billboardLeaderboardMrec('two'),
                    regionalNewsSegment('kalgoorlie-miner'),
                    waNewsSegment(options, false),
                    ...billboardLeaderboardMrec('three'),
                ],
            },
        }
    )
}
